import Axios from "axios";

export const fetchRoadConditionsStart = () => ({
  type: "FETCH_ROAD_CONDITIONS_START"
});

export const fetchRoadConditionsSuccess = (roadConditions) => ({
  type: "FETCH_ROAD_CONDITIONS_SUCCESS",
  payload: roadConditions
});

export const fetchRoadConditionsFailure = (error) => ({
  type: "FETCH_ROAD_CONDITIONS_FAILURE",
  payload: error
});
export const saveRoadConditionsStart = (roadConditions) => ({
  type: "SAVE_ROAD_CONDITIONS_START",
  payload:roadConditions
});

export const saveRoadConditionsSuccess = () => ({
  type: "SAVE_ROAD_CONDITIONS_SUCCESS",
});

export const saveRoadConditionsFailure = (error) => ({
  type: "SAVE_ROAD_CONDITIONS_FAILURE",
  payload: error
});

